import { render, staticRenderFns } from "./SmallCarItinerary.vue?vue&type=template&id=68336514&scoped=true&"
import script from "./SmallCarItinerary.vue?vue&type=script&lang=js&"
export * from "./SmallCarItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68336514",
  null
  
)

export default component.exports